import { render, staticRenderFns } from "./ProductCustomerGroups.vue?vue&type=template&id=38d125bd&"
import script from "./ProductCustomerGroups.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomerGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports